<template>
  <v-form :submit="submitUpdatePessoa">
    <v-expansion-panels class="my-5" v-model="expansionp" multiple>
      <!-- Configurações de cadastro -->
      <v-expansion-panel v-if="admin" expanded>
        <v-expansion-panel-title class="text-h6">
          <v-icon class="mr-2">mdi-shield</v-icon> Configurações de cadastro
        </v-expansion-panel-title>
        <v-expansion-panel-text>
          <v-row density="compact">
            <v-col cols="12" md="4" sm="6">
              <v-switch
                        :disabled="legal_person.id ? true : false"
                        :label="legal_person.is_human ? 'Pessoa Física' : 'Pessoa Jurídica'"
                        density="compact"
                        v-model="legal_person.is_human"></v-switch>
            </v-col>
            <v-col cols="12" md="4" sm="6">
              <v-switch
                        :label="legal_person.active ? 'Ativo' : 'Inativo'"
                        density="compact"
                        v-model="legal_person.active"></v-switch>
            </v-col>
            <v-col cols="12" md="4">
              <v-autocomplete
                              label="Tipo de cadastro"
                              item-title="label"
                              item-value="value"
                              :items="$LEGAL_PEOPLE_TYPES"
                              :readonly="legal_person.id ? true : false"
                              v-model="legal_person.type"
                              :disabled="requestingApi"
                              density="compact">
                <template v-slot:no-data>
                  <div class="px-4">Digite sua busca</div>
                </template>
              </v-autocomplete>
            </v-col>
          </v-row>
        </v-expansion-panel-text>
      </v-expansion-panel>

      <!-- Informações cadastrais -->
      <v-expansion-panel>
        <v-expansion-panel-title class="text-h6">
          <v-icon class="mr-2">mdi-file-account</v-icon> Dados cadastrais
        </v-expansion-panel-title>
        <v-expansion-panel-text>
          <v-row density="compact">
            <v-col cols="12" sm="2">
              <v-row density="compact">
                <v-col cols="12" class="text-center">
                  <v-img class="fill-height"
                         :src="profileImage"
                         max-width="70%"
                         inline>
                  </v-img>
                </v-col>
                <v-spacer></v-spacer>
                <v-col v-if="!legal_person.img" cols="12">
                  <UploadFile
                              accept-type="image/png, image/jpeg, image/bmp"
                              icon="mdi-camera"
                              :fileType="$FILE_TYPE.legal_person_picture"
                              :userId="me.id"
                              @uploaded="uploadedPhoto"
                              density="compact" />
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12" sm="10">
              <v-row density="compact">
                <v-col cols="12" md="5" sm="6">
                  <v-text-field
                                v-model="legal_person.name"
                                :rules="rules.required"
                                :label="legal_person.is_human ? 'Nome completo' : 'Nome da empresa'"
                                :disabled="requestingApi"
                                density="compact"></v-text-field>
                </v-col>
                <v-col cols="12" md="4" sm="6" v-if="!legal_person.is_human">
                  <v-text-field
                                v-model="legal_person.fantasy_name"
                                label="Nome fantasia"
                                :disabled="requestingApi"
                                density="compact"></v-text-field>
                </v-col>
                <v-col cols="12" md="3" sm="6">
                  <v-text-field
                                v-model="legal_person.ssn"
                                :rules="legal_person.id ? [] : rules.required"
                                :label="legal_person.is_human ? 'CPF' : 'CNPJ'"
                                :disabled="requestingApi"
                                v-mask="legal_person.is_human
                                  ? '###.###.###-##'
                                  : '##.###.###/####-##'
                                  "
                                density="compact"></v-text-field>
                </v-col>
                <v-col cols="12" md="2" sm="6" v-if="legal_person.is_human">
                  <v-text-field
                                label="Data de nascimento"
                                v-model="legal_person.birthdate"
                                :rules="legal_person.id ? [] : rules.required"
                                type="date"
                                :disabled="requestingApi"
                                density="compact"></v-text-field>
                </v-col>
                <v-col cols="12" md="2" sm="6" v-if="legal_person.is_human">
                  <v-autocomplete
                                  label="Gênero"
                                  :items="['Masculino', 'Feminino']"
                                  v-model="legal_person.gender"
                                  :disabled="requestingApi"
                                  density="compact">
                    <template v-slot:no-data>
                      <div class="px-4">Digite sua busca</div>
                    </template>
                  </v-autocomplete>
                </v-col>
                <v-col cols="12" sm="5" v-if="legal_person.is_human">
                  <v-text-field
                                v-model="legal_person.nationality"
                                label="Nacionalidade"
                                :disabled="requestingApi"
                                density="compact"></v-text-field>
                </v-col>
                <v-col cols="12" md="3" sm="6" v-if="!legal_person.is_human">
                  <v-text-field
                                v-model="legal_person.owner"
                                label="Proprietário"
                                :disabled="requestingApi"
                                density="compact"></v-text-field>
                </v-col>
                <v-col cols="12" md="3" sm="6" v-if="!legal_person.is_human">
                  <v-text-field
                                v-model="legal_person.company_size"
                                label="Tamanho da empresa"
                                :disabled="requestingApi"
                                density="compact"></v-text-field>
                </v-col>
                <v-col cols="12" md="3" sm="6" v-if="!legal_person.is_human">
                  <v-text-field
                                v-model="legal_person.number_of_employees"
                                label="Funcionários"
                                type="number"
                                :disabled="requestingApi"
                                density="compact"></v-text-field>
                </v-col>
                <v-col cols="12" md="3" sm="6" v-if="!legal_person.is_human">
                  <v-text-field
                                v-model="legal_person.number_of_branches"
                                label="Filiais"
                                type="number"
                                :disabled="requestingApi"
                                density="compact"></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" v-if="!legal_person.is_human">
                  <v-text-field
                                v-model="legal_person.branch_activity"
                                label="Ramo de atividade"
                                :disabled="requestingApi"
                                density="compact"></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" v-if="!legal_person.is_human">
                  <v-text-field
                                v-model="legal_person.map"
                                label="Link da localização GPS"
                                :disabled="requestingApi"
                                density="compact"></v-text-field>
                </v-col>
                <v-col v-if="!!legal_person.img" cols="12">
                  <v-text-field
                                v-model="legal_person.img"
                                label="URL da imagem"
                                :disabled="requestingApi"
                                clearable
                                density="compact"></v-text-field>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-expansion-panel-text>
      </v-expansion-panel>

      <!-- Informações DE ACESSO - USUÁRIO -->
      <v-expansion-panel v-if="legal_person.id">
        <v-expansion-panel-title class="text-h6">
          <v-icon class="mr-2">mdi-account-key</v-icon> Dados de acesso ao sistema
        </v-expansion-panel-title>
        <v-expansion-panel-text>
          <FormUser
                    :user="user"
                    :editUser="legal_person.user"
                    :legalPersonId="legal_person.id"
                    @updated="updatedUser" />
        </v-expansion-panel-text>
      </v-expansion-panel>

      <!-- Dados para contato -->
      <v-expansion-panel>
        <v-expansion-panel-title class="text-h6">
          <v-icon class="mr-2">mdi-phone</v-icon> Dados para contato
        </v-expansion-panel-title>
        <v-expansion-panel-text>
          <v-row density="compact">
            <v-col cols="12" lg="8" md="7">
              <v-text-field
                            v-model="legal_person.notification_email"
                            label="E-mail de notificação"
                            type="email"
                            :disabled="requestingApi"
                            density="compact"></v-text-field>
            </v-col>
            <v-col cols="4" lg="1" md="2" sm="3">
              <v-select
                        :items="['+55']"
                        v-model="legal_person.notification_phone_international_code"
                        density="compact">
              </v-select>
            </v-col>
            <v-col cols="8" lg="3" md="3" sm="9">
              <v-text-field v-mask="'(##) ##### ####'" v-model="legal_person.notification_phone"
                label="Telefone de notificação" :rules="rules.phoneNumber" :disabled="requestingApi" density="compact">
                <template v-slot:append>
                  <v-tooltip v-if="!legal_person.whatsapp_status || legal_person.whatsapp_status == 'pending'" text="Não confirmado - Clique para reenviar confirmação">
                    <template v-slot:activator="{ props }">
                      <v-icon v-bind="props" color="yellow" @click="resendWhatsAppConfirmation" style="cursor: pointer;">mdi-alert</v-icon>
                    </template>
                  </v-tooltip>
                  <v-tooltip v-if="legal_person.whatsapp_status == 'accepted'" text="Confirmado">
                    <template v-slot:activator="{ props }">
                      <v-icon v-bind="props" color="green" style="cursor: pointer;">mdi-check</v-icon>
                    </template>
                  </v-tooltip>
                  <v-tooltip v-if="legal_person.whatsapp_status == 'denied'" text="Desabilitada pelo usuário - Clique para reenviar confirmação">
                    <template v-slot:activator="{ props }">
                      <v-icon v-bind="props" color="red" @click="resendWhatsAppConfirmation" style="cursor: pointer;">mdi-alert-octagon-outline</v-icon>
                    </template>
                  </v-tooltip>
                </template>
              </v-text-field>
            </v-col>
            <v-col cols="12" md="4" sm="6">
              <v-text-field
                            v-model="legal_person.phone"
                            label="Telefone 1"
                            :disabled="requestingApi"
                            density="compact"></v-text-field>
            </v-col>
            <v-col cols="12" md="4" sm="6">
              <v-text-field
                            v-model="legal_person.phone2"
                            label="Telefone 2"
                            :disabled="requestingApi"
                            density="compact"></v-text-field>
            </v-col>
            <v-col cols="12" md="4" sm="6">
              <v-text-field
                            v-model="legal_person.phone3"
                            label="Telefone 3"
                            :disabled="requestingApi"
                            density="compact"></v-text-field>
            </v-col>
          </v-row>
        </v-expansion-panel-text>
      </v-expansion-panel>

      <!-- Ficha Médica -->
      <v-expansion-panel
                         v-if="legal_person &&
                           legal_person.is_human &&
                           legal_person.type == $LEGAL_PEOPLE_TYPES_DIC.PADRAO
                           ">
        <v-expansion-panel-title class="text-h6">
          <v-icon class="mr-2">mdi-medication</v-icon> Ficha Médica
        </v-expansion-panel-title>
        <v-expansion-panel-text>
          <FichaMedica
                       :user="user"
                       :legalPerson="legal_person"
                       :admin="admin"
                       @updated="updatedMedicalRecord" />
        </v-expansion-panel-text>
      </v-expansion-panel>

      <!-- Endereço -->
      <v-expansion-panel>
        <v-expansion-panel-title class="text-h6">
          <v-icon class="mr-2">mdi-home-city</v-icon> Endereço
        </v-expansion-panel-title>
        <v-expansion-panel-text>
          <v-row density="compact">
            <v-col cols="12" md="4" sm="6">
              <v-text-field
                            v-model="legal_person.address_zip"
                            label="CEP"
                            :disabled="requestingApi"
                            density="compact"></v-text-field>
            </v-col>
            <v-col cols="12" md="5" sm="6">
              <v-text-field
                            v-model="legal_person.address_street"
                            label="Endereço"
                            :disabled="requestingApi"
                            density="compact"></v-text-field>
            </v-col>
            <v-col cols="12" md="3" sm="6">
              <v-text-field
                            v-model="legal_person.address_number"
                            label="Número"
                            :disabled="requestingApi"
                            density="compact"></v-text-field>
            </v-col>

            <v-col cols="12" md="3" sm="6">
              <v-autocomplete
                              label="País"
                              :items="functions.g.allCountries()"
                              v-model="legal_person.address_country"
                              :disabled="requestingApi"
                              density="compact">
                <template v-slot:no-data>
                  <div class="px-4">Digite sua busca</div>
                </template></v-autocomplete>
            </v-col>
            <v-col cols="12" md="3" sm="6">
              <v-autocomplete
                              label="Estado (UF)"
                              :items="functions.g.allBrazilianStates()"
                              item-title="title"
                              item-value="uf"
                              v-model="legal_person.address_state"
                              :disabled="requestingApi"
                              density="compact">
                <template v-slot:no-data>
                  <div class="px-4">Digite sua busca</div>
                </template></v-autocomplete>
            </v-col>
            <v-col cols="12" md="3" sm="6">
              <v-text-field
                            v-model="legal_person.address_city"
                            label="Cidade"
                            :disabled="requestingApi"
                            density="compact"></v-text-field>
            </v-col>
            <v-col cols="12" md="3" sm="6">
              <v-text-field
                            v-model="legal_person.address_district"
                            label="Bairro"
                            :disabled="requestingApi"
                            density="compact"></v-text-field>
            </v-col>

            <v-col cols="12">
              <v-text-field
                            v-model="legal_person.address_other"
                            label="Complemento"
                            :disabled="requestingApi"
                            density="compact"></v-text-field>
            </v-col>
          </v-row>
        </v-expansion-panel-text>
      </v-expansion-panel>

      <!-- Informações cadastrais -->
      <v-expansion-panel>
        <v-expansion-panel-title class="text-h6">
          <v-icon class="mr-2">mdi-bank</v-icon> Dados bancários
        </v-expansion-panel-title>
        <v-expansion-panel-text>
          <v-row density="compact">
            <v-col cols="12">
              <v-autocomplete
                              label="Selecione o banco"
                              :items="brazilianBanksCodeNames"
                              v-model="legal_person.bank_code_name"
                              :disabled="requestingApi"
                              density="compact">
                <template v-slot:no-data>
                  <div class="px-4">Digite sua busca</div>
                </template></v-autocomplete>
            </v-col>
            <v-col cols="12" md="6" sm="6">
              <v-text-field
                            v-model="legal_person.bank_account_number"
                            label="Número da conta (com dígito)"
                            :disabled="requestingApi"
                            density="compact"></v-text-field>
            </v-col>
            <v-col cols="12" md="6" sm="6">
              <v-text-field
                            v-model="legal_person.bank_account_agency"
                            label="Agência (com dígito)"
                            :disabled="requestingApi"
                            density="compact"></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field
                            v-model="legal_person.bank_pix"
                            label="Chave PIX"
                            prepend-inner-icon="mdi-key"
                            :disabled="requestingApi"
                            density="compact"></v-text-field>
            </v-col>
          </v-row>
        </v-expansion-panel-text>
      </v-expansion-panel>

      <!-- União dos Escoteiros do Brasil -->
      <v-expansion-panel
                         v-if="legal_person.is_human && legal_person.type == $LEGAL_PEOPLE_TYPES_DIC.PADRAO">
        <v-expansion-panel-title class="text-h6">
          <v-icon class="mr-2">mdi-fleur-de-lis</v-icon>
          Entidade Escoteira
        </v-expansion-panel-title>
        <v-expansion-panel-text>
          <v-row density="compact">
            <v-col cols="12" md="4" sm="6">
              <v-text-field
                            v-model="legal_person.email_ueb"
                            label="E-mail"
                            type="email"
                            :disabled="requestingApi"
                            density="compact"></v-text-field>
            </v-col>
            <v-col cols="12" md="4" sm="6">
              <v-text-field
                            v-model="legal_person.reg_ueb"
                            label="Registro"
                            :disabled="requestingApi"
                            density="compact"></v-text-field>
            </v-col>
            <v-col cols="12" md="4" sm="6">
              <v-text-field
                            v-model="legal_person.date_ueb"
                            label="Data de cadastro"
                            :disabled="requestingApi"
                            density="compact"></v-text-field>
            </v-col>
          </v-row>
        </v-expansion-panel-text>
      </v-expansion-panel>
    </v-expansion-panels>
    <v-row density="compact">
      <v-col cols="12">
        <v-textarea label="Observações do cadastro" />
      </v-col>
      <v-col cols="12" v-if="admin && legal_person.is_human && legal_person.id">
        <ListFromTo
                    title="Dependentes"
                    :listFrom="legalPeople"
                    :listTo="children"
                    @updated="updateLegalPersonChildren"
                    listFromKey="name"
                    listToKey="name"
                    density="compact">
          <template v-slot:search>
            <div>
              <v-form :submit="searchPeople">
                <v-text-field
                              label="Pesquisar pessoas pelo nome"
                              hide-details
                              v-model="searchText"
                              @click:append-inner="searchPeople"
                              clearable
                              append-inner-icon="mdi-magnify"
                              density="compact">
                </v-text-field>
              </v-form>
            </div>
          </template>
        </ListFromTo>
      </v-col>
      <v-col cols="12" v-if="admin && legal_person.is_human && legal_person.id">
        <ListFromTo
                    title="Responsáveis"
                    :listFrom="legalPeopleParents"
                    :listTo="parents"
                    @updated="updateLegalPersonParents"
                    listFromKey="name"
                    listToKey="name"
                    density="compact">
          <template v-slot:search>
            <div>
              <v-form :submit="searchPeopleParent">
                <v-text-field
                              label="Pesquisar pessoas pelo nome"
                              hide-details
                              v-model="searchTextParent"
                              @click:append-inner="searchPeopleParent"
                              clearable
                              append-inner-icon="mdi-magnify"
                              density="compact">
                </v-text-field>
              </v-form>
            </div>
          </template>
        </ListFromTo>
      </v-col>
      <v-col cols="12" v-if="admin && legal_person.id">
        <ListFromTo
                    title="Grupos/Tropas"
                    :listFrom="legalPeopleSubGroups"
                    :listTo="selSubgroups"
                    @updated="updateSubgroups"
                    listFromKey="name"
                    listToKey="name"
                    density="compact">
          <template v-slot:search>
            <div>
              <v-form :submit="searchSubgroup">
                <v-text-field
                              label="Pesquisar grupo/tropa"
                              hide-details
                              v-model="searchTextSubgroup"
                              @click:append-inner="searchSubgroup"
                              clearable
                              append-inner-icon="mdi-magnify"
                              density="compact">
                </v-text-field>
              </v-form>
            </div>
          </template>
        </ListFromTo>
      </v-col>
      <v-col cols="12" class="text-right mb-2">
        <v-btn color="success" type="submit" density="compact">
          <v-icon class="mr-2">mdi-content-save</v-icon>
          Salvar
        </v-btn>
      </v-col>
    </v-row>
  </v-form>
</template>
<script>
import FichaMedica from "./FichaMedica.vue";
import FormUser from "./FormUser.vue";
import ListFromTo from "./ListFromTo.vue";
import UploadFile from "./UploadFile.vue";
import assets from "../assets/assets";
import api from '@/services'
import functions, { allBrazilianStates, allCountries } from '@/services/Functions'

export default {
  setup() {
    return { functions }
  },
  components: { ListFromTo, UploadFile, FormUser, FichaMedica },
  props: {
    user: Object,
    me: Object,
    admin: Boolean,
    group_id: Number,
    personType: Number,
  },
  data() {
    return {
      assets: assets,
      requestingApi: null,
      expansionp: [0, 1],
      brazilianBanks: [],
      legal_person: {
        user_id: null,
        is_human: true,
        type: 0,
        name: null,
        img: null,
        ssn: null,
        doc1: null,
        doc2: null,
        doc3: null,
        gender: null,
        birthdate: null,
        profession: null,
        workplace: null,
        nationality: null,
        martial_status: null,
        average_income: null,
        number_of_children: null,
        schooling_level: null,
        fantasy_name: null,
        notification_email: null,
        notification_phone_international_code: '+55',
        notification_phone: null,
        owner: null,
        company_size: null,
        number_of_employees: null,
        number_of_branches: null,
        branch_activity: null,
        map: null,
        address_zip: null,
        address_street: null,
        address_number: null,
        address_other: null,
        address_country: null,
        address_state: null,
        address_city: null,
        address_district: null,
        email_ueb: null,
        reg_ueb: null,
        date_ueb: null,
        phone: null,
        phone2: null,
        phone3: null,
        bank_code_name: null,
        bank_account_number: null,
        bank_account_agency: null,
        bank_pix: null,
        note: null,
      },
      searchText: null,
      lstLegalPeople: [],
      lstLegalPeopleParents: [],
      allSubgroups: [],
      searchTextSubgroup: null,
      searchTextParent: null,
      rules: {
        required: [(v) => !!v || "Campo obrigatório"],
        phoneNumber: [
          (value) => {
            // const pattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{6,})/;
            const pattern = /^\d{10}$|^\d{11}$/;
            return value ? (pattern.test(this.notificationPhoneRaw) || "Precisa ser um número de telefone válido: (XX) 9 9999 9999 ou (XX) 3333 9999)") : true;
          },
        ]
      },
    };
  },
  created() {
    var vm = this;

    if (vm.me?.legal_person) {
      vm.legal_person = vm.me?.legal_person;
      if (vm.legal_person?.id) {
        vm.openLegalPersonToEdit(vm.legal_person.id);
      }
    } else {
      vm.legal_person = vm.generateEmptyLegalPerson();
    }
    if (vm.personType)
      vm.legal_person.type = vm.personType;
    vm.fetchAllBanks();
  },
  mounted() { },
  activated() { },
  methods: {
    updatedUser() {
      var vm = this;
      vm.openLegalPersonToEdit(vm.legal_person.id);
    },
    updatedMedicalRecord(object) {
      var vm = this;
      vm.openLegalPersonToEdit(vm.legal_person.id);
    },
    uploadedPhoto(image) {
      var vm = this;
      vm.legal_person.img = image?.path;
    },
    openLegalPersonToEdit(id) {
      var vm = this;
      vm.requestingApi = true;
      return new Promise((resolve, reject) => {
        api.legalPerson
          .get(id)
          .then((result) => {
            vm.legal_person = result;
          })
          .catch((err) => {
            if (err.message) {
              vm.$notify({
                type: "warn",
                text: err.message,
              });
            }
          })
          .finally(() => {
            vm.requestingApi = false;
          });
      });
    },
    fetchAllBanks() {
      var vm = this;
      vm.requestingApi = true;
      return new Promise((resolve, reject) => {
        api.bank
          .list()
          .then((result) => {
            vm.brazilianBanks = result;
          })
          .catch((err) => {
            if (err.message) {
              vm.$notify({
                type: "warn",
                text: err.message,
              });
            }
          })
          .finally(() => {
            vm.requestingApi = false;
          });
      });
    },
    searchPeople() {
      var vm = this;

      vm.requestingApi = true;
      return new Promise((resolve, reject) => {
        api.legalPerson
          .search({ searchText: vm.searchText })
          .then((result) => {
            vm.lstLegalPeople = result;
          })
          .catch((err) => {
            if (err.message) {
              vm.$notify({
                type: "warn",
                text: err.message,
              });
            }
          })
          .finally(() => {
            vm.requestingApi = false;
          });
      });
    },
    searchPeopleParent() {
      var vm = this;
      vm.requestingApi = true;
      return new Promise((resolve, reject) => {
        api.legalPerson
          .search({ searchText: vm.searchTextParent })
          .then((result) => {
            vm.lstLegalPeopleParents = result;
          })
          .catch((err) => {
            if (err.message) {
              vm.$notify({
                type: "warn",
                text: err.message,
              });
            }
          })
          .finally(() => {
            vm.requestingApi = false;
          });
      });
    },
    searchSubgroup() {
      var vm = this;
      vm.requestingApi = true;
      return new Promise((resolve, reject) => {
        api.subGroup
          .search({ searchText: vm.searchTextSubgroup })
          .then((result) => {
            vm.allSubgroups = result;
          })
          .catch((err) => {
            if (err.message) {
              vm.$notify({
                type: "warn",
                text: err.message,
              });
            }
          })
          .finally(() => {
            vm.requestingApi = false;
          });
      });
    },
    updateLegalPersonChildren(newList) {
      var vm = this;
      vm.requestingApi = true;
      return new Promise((resolve, reject) => {
        api.legalPersonParent
          .update({
            parent_id: vm.legal_person.id,
            children: newList,
          })
          .then((result) => {
            vm.$emit("updated");
            vm.$notify({
              type: "success",
              text: "Dados alterados com sucesso",
            });
            vm.openLegalPersonToEdit(vm.legal_person.id);
          })
          .catch((err) => {
            if (err.message) {
              vm.$notify({
                type: "warn",
                text: err.message,
              });
            }
          })
          .finally(() => {
            vm.requestingApi = false;
          });
      });
    },
    updateLegalPersonParents(newList) {
      var vm = this;
      vm.requestingApi = true;
      return new Promise((resolve, reject) => {
        api.legalPersonParent
          .update({
            child_id: vm.legal_person.id,
            parents: newList,
          })
          .then((result) => {
            vm.$emit("updated");
            vm.$notify({
              type: "success",
              text: "Dados alterados com sucesso",
            });
            vm.openLegalPersonToEdit(vm.legal_person.id);
          })
          .catch((err) => {
            if (err.message) {
              vm.$notify({
                type: "warn",
                text: err.message,
              });
            }
          })
          .finally(() => {
            vm.requestingApi = false;
          });
      });
    },
    updateSubgroups(newList) {
      var vm = this;
      vm.requestingApi = true;
      const data = {
        legal_person_id: vm.legal_person.id,
        subgroup_ids: newList.map(sg => sg.id)
      }
      return new Promise((resolve, reject) => {
        api.subGroupMember
          .insertMultiGroups(data)
          .then((result) => {
            vm.$emit("updated");
            vm.$notify({
              type: "success",
              text: "Dados alterados com sucesso",
            });
          })
          .catch((err) => {
            if (err.message) {
              vm.$notify({
                type: "warn",
                text: err.message,
              });
            }
          })
          .finally(() => {
            vm.requestingApi = false;
          });
      });
    },
    submitUpdatePessoa() {
      var vm = this;

      vm.requestingApi = true;
      return new Promise((resolve, reject) => {
        let _legalPerson = {
          user_id: vm.legal_person?.user_id || vm.me?.id,
          ...vm.legal_person,
        };
        _legalPerson.notification_phone = vm.notificationPhoneRaw
        if (!_legalPerson.group_id) {
          let _group = api.storage.selectedGroup();
          if (_group && _group.id) {
            _legalPerson.group_id = _group.id;
          } else if (vm.user?.access_level >= vm.$USER_ACCESS_LEVELS_DIC.ADMIN.value) {
            _legalPerson.group_id = vm.group_id || null;
          } else {
            vm.requestingApi = false;
            vm.$notify({
              type: "warn",
              text: "Nenhum grupo selecionado",
            });
            reject(new Error("Nenhum grupo selecionado"));
            return;
          }
        }
        api.legalPerson[
          vm.admin ? "updateMyLegalPersonAdmin" : "updateMyLegalPerson"
        ](_legalPerson)
          .then((result) => {
            vm.legal_person = { ..._legalPerson, ...result };
            vm.$emit("updated", vm.legal_person);
            vm.$notify({
              type: "success",
              text: "Dados alterados com sucesso",
            });
          })
          .catch((err) => {
            if (err.message) {
              vm.$notify({
                type: "warn",
                text: err.message,
              });
            }
          })
          .finally(() => {
            vm.requestingApi = false;
          });
      });
    },
    generateEmptyLegalPerson() {
      return {
        user_id: null,
        is_human: true,
        active: true,
        type: 0,
        name: null,
        img: null,
        ssn: null,
        doc1: null,
        doc2: null,
        doc3: null,
        gender: null,
        birthdate: null,
        profession: null,
        workplace: null,
        nationality: null,
        martial_status: null,
        average_income: null,
        number_of_children: null,
        schooling_level: null,
        fantasy_name: null,
        notification_email: null,
        notification_phone_international_code: '+55',
        notification_phone: null,
        owner: null,
        company_size: null,
        number_of_employees: null,
        number_of_branches: null,
        branch_activity: null,
        map: null,
        address_zip: null,
        address_street: null,
        address_number: null,
        address_other: null,
        address_country: null,
        address_state: null,
        address_city: null,
        address_district: null,
        email_ueb: null,
        reg_ueb: null,
        date_ueb: null,
        phone: null,
        phone2: null,
        phone3: null,
        bank_code_name: null,
        bank_account_number: null,
        bank_account_agency: null,
        bank_pix: null,
        note: null,
      };
    },
    resendWhatsAppConfirmation() {
      var vm = this;
      
      if (!vm.legal_person?.id) {
        vm.$notify({
          type: "warn",
          text: "Pessoa jurídica deve ser salva primeiro",
        });
        return;
      }

      if (!vm.legal_person?.notification_phone) {
        vm.$notify({
          type: "warn",
          text: "Número de telefone não encontrado",
        });
        return;
      }

      vm.requestingApi = true;
      return new Promise((resolve, reject) => {
        api.legalPerson
          .resendWhatsAppConfirmation(vm.legal_person.id)
          .then((result) => {
            vm.$notify({
              type: "success",
              text: "Mensagem de confirmação reenviada com sucesso",
            });
          })
          .catch((err) => {
            if (err.message) {
              vm.$notify({
                type: "warn",
                text: err.message,
              });
            }
          })
          .finally(() => {
            vm.requestingApi = false;
          });
      });
    },
  },
  computed: {
    notificationPhoneRaw() {
      var vm = this;

      return vm.legal_person?.notification_phone ? vm.legal_person.notification_phone.replace(/\D/g, '') : null
    },
    profileImage() {
      const vm = this;

      if (vm.legal_person?.img) return vm.legal_person.img;
      if (vm.legal_person?.gender === 'Masculino') return assets.default_male_profile;
      if (vm.legal_person?.gender === 'Feminino') return assets.default_female_profile;
      return vm.assets.profile_placeholder;
    },
    brazilianBanksCodeNames() {
      var vm = this;
      let _lstCodeName = [];
      vm.brazilianBanks.forEach((bank) => {
        if (bank.code) {
          let _codeName = `${bank.code < 10
            ? `000${bank.code}`
            : bank.code < 100
              ? `00${bank.code}`
              : bank.code < 1000
                ? `0${bank.code}`
                : bank.code
            } ${bank.fullName}`;
          _lstCodeName.push(_codeName);
        }
      });
      return _lstCodeName;
    },
    children() {
      var vm = this;
      let _lps = [];
      try {
        if (vm.legal_person.children) {
          vm.legal_person.children.forEach((child) => {
            _lps.push({
              ...child.legal_person,
            });
          });
        }
      } catch (error) {
        console.error(error);
      }
      return _lps;
    },
    parents() {
      var vm = this;
      let _lps = [];
      try {
        if (vm.legal_person.parents) {
          vm.legal_person.parents.forEach((parent) => {
            _lps.push({
              ...parent.parent_person,
            });
          });
        }
      } catch (error) {
        console.error(error);
      }
      return _lps;
    },
    selSubgroups() {
      var vm = this;

      return vm.legal_person.subgroups;
    },
    legalPeople() {
      var vm = this;
      let _lps = [];
      try {
        vm.lstLegalPeople.forEach((ppl) => {
          _lps.push({
            ...ppl,
          });
        });
      } catch (error) {
        //
      }
      return _lps;
    },
    legalPeopleParents() {
      var vm = this;
      return vm.lstLegalPeopleParents;
    },
    legalPeopleSubGroups() {
      const vm = this;

      return vm.allSubgroups;
    },
  },
  watch: {
    me(newMe) {
      if (newMe?.legal_person) {
        this.legal_person = newMe.legal_person;
        if (this.legal_person?.id) {
          this.openLegalPersonToEdit(this.legal_person.id);
        }
      } else {
        this.legal_person = this.generateEmptyLegalPerson();
      }
    },
  },
};
</script>